import React, { ReactElement } from 'react'
import { List, ListItemText } from '@mui/material'
import { ProgramGroupReference } from 'src/service/backend/api'

interface ProgramRelatedGroupsProps {
  programGroups: ProgramGroupReference[] | undefined
  warningMessage: string
}

export const ProgramRelatedGroups = ({ programGroups, warningMessage }: ProgramRelatedGroupsProps): ReactElement => {
  if (!programGroups || programGroups.length === 0) {
    return <></>
  }

  return (
    <>
      {warningMessage}
      <List
        sx={{
          width: '100%',
          overflow: 'auto',
          maxHeight: 150,
          my: 2,
        }}
        dense
      >
        {programGroups.map((pg) => (
          <ListItemText key={pg.id} secondary={pg.name} />
        ))}
      </List>
    </>
  )
}
